export default {
  timeout: 10 * 1000,
  // host: "https://qqcnewapi.qzappapia456.com",
  host: "https://jk.8f9j9n.com", // 正式
  webKey: "luckygogointch-intech",
  endPoint: "H5",
};
